// extracted by mini-css-extract-plugin
module.exports = {"coming-soon-container":"ComingSoonButton_coming-soon-container__1I_Fo","coming-soon":"ComingSoonButton_coming-soon__3tNzd"};